<template>
  <v-app id="app">
    <div class="loader" :class="getloadingState ? 'active' : ''">
      <div class="loader-item">
        <div class="loader-wheel"></div>
        <div class="loader-text"></div>
      </div>
    </div>
    <v-main v-if="getRequestAllFlag">
      <router-view
        v-if="getRequestAllFlag"
        :key="$route.fullPath"
      ></router-view>
    </v-main>
  </v-app>
</template>

<script>
// import "@/assets/js/jquery-1.9.1.min.js";
// import "@/assets/js/jQuery.print.js";
// import "@/assets/js/jquery-ui.js";
// import "@/assets/js/excanvas.js";
import { mapGetters } from "vuex";
import myMixin from "@/mixin/mixin";

export default {
  name: "App",
  mixins: [myMixin],
  components: {},
  created() {
    this.$nextTick(function() {
      setTimeout(() => {
        this.$store.dispatch("REQUEST_ALL_CODE_LIST");
      }, 1000);
    });
  },
  mounted() {},
  updated() {},
  computed: {
    ...mapGetters([
      "getloadingState",

      "getRequestAllFlag",
      "getMainObituaryList"
    ])
  },
  methods: {}
};
</script>

<style>
@import "./assets/css/style.css";
</style>
